import { useDoorTailgateGridsEnabledQuery } from '@/graphql/generated/hooks'
import { DeviceType } from '@/graphql/generated/schemas'

interface UseCameraNameIProps {
  deviceId: string | undefined
  deviceName: string | undefined
  deviceType: DeviceType | undefined
}

/**
 * Returns the camera name for ClipLoader display.
 *
 * - If device is a Camera: returns device name directly
 * - If device is a Door: fetches and returns the associated camera name
 * - Otherwise: returns 'Camera' as fallback
 */
export const useCameraName = ({
  deviceId,
  deviceName,
  deviceType,
}: UseCameraNameIProps): string => {
  // Only query if device is a Door
  const shouldQuery = deviceType === DeviceType.Door && Boolean(deviceId)

  const { data } = useDoorTailgateGridsEnabledQuery({
    variables: { id: deviceId ?? '' },
    skip: !shouldQuery,
  })

  // If Camera type, use device name directly
  if (deviceType === DeviceType.Camera) {
    return deviceName ?? 'Camera'
  }

  // If Door type, get camera name from tailgateGrids
  if (deviceType === DeviceType.Door) {
    const cameraName = data?.device?.door?.tailgateGrids?.[0]?.camera?.name
    return cameraName ?? 'Camera'
  }

  // Fallback for other device types
  return 'Camera'
}
